import React, { Component } from 'react';
import { Modal } from 'react-responsive-modal';

export class VerifyModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      changeTabs: "authentication_code",
    };
  }

  toggleChangeTabs = (name) => {
    this.setState({
      changeTabs: name,
    });
  }

  imageImport = (r) => {
    let images = {};
    r.keys().map((item) => {
      return (images[item.replace("./", "")] = r(item)["default"]);
    });
    return images;
  };

  render() {

    const icon = this.imageImport(require.context("../../assets/images/loginregister/", false, /\.(png|jpe?g|svg|webp)$/));

    return (
      <Modal
        open={this.props.openVerifyModal}
        onClose={this.props.toggleVerifyModal}
        center
      >
        <div className='modal-content'>
          {
            this.props.openVerifyModal === true ? (
              <>
                <div className='modal-header'>
                  <h4 className="modal-title">Security Verification</h4>
                  <p>The system detects the current login abnormalities. For your account security, please go to security verification.</p>
                </div>
                <div className='modal-body'>
                  <div className='underline-nav-tabs'>
                    <ul className='nav nav-tabs'>
                      <li className="nav-item">
                        <a className={`nav-link ${this.state.changeTabs === 'authentication_code' ? 'active' : ''}`} role="button" onClick={() => this.toggleChangeTabs("authentication_code")}>
                          <p>Authentication Code</p>
                        </a>
                      </li>
                      <li className="nav-item">
                        <a className={`nav-link ${this.state.changeTabs === 'security_answer' ? 'active' : ''}`} role="button" onClick={() => this.toggleChangeTabs("security_answer")}>
                          <p>Security Answer</p>
                        </a>
                      </li>
                    </ul>
                  </div>
                  {this.state.changeTabs === "authentication_code" ?
                    (<form method="post" name="authentication_code_form" >
                      <p>Authentication Code</p>
                      <div className="input-group">
                        <input
                          type="text"
                          id="registerUsername"
                          className="form-control"
                          required=""
                          placeholder="Please insert authentication code"
                        />
                      </div>
                    </form>
                    )  : (
                    this.state.changeTabs === "security_answer" &&
                    <form method="post" name="security_answer_form" >
                      <p>Food <img src={icon["loading.png"]} alt="hide pwd" /></p>
                      <div className="input-group">
                        <input
                          type="text"
                          id="registerUsername"
                          className="form-control"
                          required=""
                          placeholder="Please enter secret answer"
                        />
                      </div>
                    </form>
                  
                    )}

                  <div className='d-grid gap-2 col-6 mx-auto mt-3'>
                    <button className='btn btn-gradient-blue mt-4'>Submit</button>
                    <button className='just-blue-btn mt-2'>Joint Venture Consultation</button>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className='modal-header'>
                  <h4 className="modal-title">Edit Mobile Number</h4>
                  <p>For your safety, the information cannot be modified after confirmation, please contact customer service if you need help.</p>
                </div>
                <div className='modal-body'>

                </div>
              </>
            )
          }
        </div>

      </Modal>
    )
  }
}

export default VerifyModal